import './prototype';
import { getSetGlobalLocale } from './locales';
import toInt from '../utils/to-int';
getSetGlobalLocale('en', {
  eras: [{
    since: '0001-01-01',
    until: +Infinity,
    offset: 1,
    name: 'Anno Domini',
    narrow: 'AD',
    abbr: 'AD'
  }, {
    since: '0000-12-31',
    until: -Infinity,
    offset: 1,
    name: 'Before Christ',
    narrow: 'BC',
    abbr: 'BC'
  }],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function ordinal(number) {
    var b = number % 10,
        output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
    return number + output;
  }
});